import { FunctionComponent } from 'react'

import cx from 'classnames'

import Icon from 'components/shared/Icon'

const ToolbarIcon: FunctionComponent<ToolbarIconProps> = ({ label, icon, active, onToggle, style }) => (
  <li
    className={cx('toolbar-icon', { active })}
    onMouseDown={(e) => {
      e.preventDefault()
      onToggle(style)
    }}
  >
    {label || <Icon name={icon} className='w7 mv2' />}
  </li>
)

interface ToolbarIconProps {
  label: string;
  icon: string;
  active: boolean;
  onToggle: (value: string) => void;
  style: string;
}

export default ToolbarIcon
